<template>
  <div class="manage-cost">
    <div class="picker">
      <div class="picker-item">使用率：{{usage}}</div>
      <div class="picker-item">
        <el-date-picker v-model="monthData"
                        type="month"
                        placeholder="">
        </el-date-picker>
      </div>

    </div>
    <div id="manageCost"></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import store from "@/store/index";
import moment from "moment";
// import { option } from "../../assets/chartData/manageCost";
export default {
  props: {
    clientWidth: {
      type: Number,
      default: () => {
        return null;
      },
    },
    manageInfo: {
      type: Object,
      default: () => {
        return null;
      },
    },
    changeWidth: {
      type: Boolean,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      myChart: null,
      echartData: {},
      option: {},
      xData: [],
      value: [],
      usage: "--",
      colorArray: [
        {
          top: "#d5865b", //黄
          bottom: "#705b56",
        },
        {
          top: "#6cc4fe", //蓝
          bottom: "#6092a8",
        },
        {
          top: "#6cfdb1", //绿
          bottom: "#639e96",
        },
      ],
      monthData: "", //选择月份
    };
  },
  watch: {
    manageInfo: {
      handler: function () {
        if (this.manageInfo.usageList.isNull) {
          this.usage = "--";
        } else {
          this.usage = this.manageInfo.usageList.data + "%";
        }
        this.initData();
      },
      deep: true,
    },
    monthData(newV) {
      moment.defaultFormat = "YYYY-MM";
      let changeMonth = moment(newV, moment.defaultFormat).toDate();
      let month = moment(changeMonth).format("YYYYMM");
      store.dispatch("SET_COST_MONTH", month);
    },
    changeWidth(newV) {
      if (newV) {
        this.initData();
      }
    },
  },
  mounted() {
    this.monthData = moment().format("YYYY-MM");
    this.initData();
  },
  methods: {
    initChart(data, chart) {
      data && chart.setOption(data);
    },
    handlerData() {
      this.xData = [];
      this.value = [];
      this.echartData = [
        {
          label: "预算金额",
          data: this.manageInfo.budgetList,
          color: { top: "#6cc4fe", bottom: "#5f90a5" },
        },
        {
          label: "已出账单成本",
          data: this.manageInfo.costList,
          color: { top: "#6cfdb1", bottom: "#5e9993" },
        },
      ];
      this.echartData.forEach((item) => {
        const label = item.label || "";
        this.xData.push(label);
        const value = item.data;
        this.value.push({ value: value.data, isNull: value.isNull });
      });
    },
    initData() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      var chartDom = document.getElementById("manageCost");
      this.myChart = echarts.init(chartDom);

      this.handlerData();

      if (this.clientWidth <= 1921) {
        this.initDataUnder1920();
      } else if (this.clientWidth > 1921 && this.clientWidth <= 2560) {
        this.initDataUnder2560();
      } else {
        this.initDataUp4368();
      }

      this.initChart(this.option, this.myChart);
    },
    initDataUnder1920() {
      this.option = {
        grid: {
          left: "-20",
          right: "-20",
          bottom: "36",
          top: "10%",
        },
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 12,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        xAxis: {
          type: "category",
          data: this.xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#253448",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "12",
            color: "#ccc",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "12",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            barCategoryGap: "60%",
            barWidth: 30,
            data: this.value,
            label: {
              show: true,
              position: "top",
              formatter: (params) => {
                if (params.data.isNull) {
                  return "--";
                } else {
                  return params.data.value;
                }
              },
              // "{c}"
              fontSize: "12",
              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorArray.length;
                return {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorArray[params.dataIndex % num].top,
                    },
                    {
                      offset: 1,
                      color: this.colorArray[params.dataIndex % num].bottom,
                    },
                  ],
                  global: false,
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
          },
        ],
      };
    },
    initDataUnder2560() {
      this.option = {
        grid: {
          left: "-30",
          right: "-30",
          bottom: "66",
          top: "3%",
        },
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 24,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        xAxis: {
          type: "category",
          data: this.xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#253448",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "24",
            color: "#ccc",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "24",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            barCategoryGap: "60%",
            barWidth: 50,
            data: this.value,
            label: {
              show: true,
              position: "top",
              formatter: "{c}",
              fontSize: "24",

              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorArray.length;
                return {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorArray[params.dataIndex % num].top,
                    },
                    {
                      offset: 1,
                      color: this.colorArray[params.dataIndex % num].bottom,
                    },
                  ],
                  global: false,
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
          },
        ],
      };
    },
    initDataUp4368() {
      this.option = {
        grid: {
          left: "-60",
          right: "-60",
          bottom: "80",
          top: "7%",
        },
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 30,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        xAxis: {
          type: "category",
          data: this.xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#253448",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "30",
            color: "#ccc",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "30",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            barCategoryGap: "60%",
            barWidth: 70,
            data: this.value,
            label: {
              show: true,
              position: "top",
              formatter: "{c}",
              fontSize: "30",

              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorArray.length;
                return {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorArray[params.dataIndex % num].top,
                    },
                    {
                      offset: 1,
                      color: this.colorArray[params.dataIndex % num].bottom,
                    },
                  ],
                  global: false,
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
          },
        ],
      };
    },
    initDataUp6720() {
      this.option = {
        grid: {
          left: "-50",
          right: "-50",
          bottom: "120",
          top: "10%",
        },
        tooltip: {
          show: false,
          // trigger: 'axis',
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            align: "left",
            fontSize: 40,
          },
          backgroundColor: "rgba(72, 156, 255, 0.6)",
          borderColor: "rgba(0, 0, 0, 0)",
        },
        xAxis: {
          type: "category",
          data: this.xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#253448",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "40",
            color: "#ccc",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
            fontSize: "40",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            barCategoryGap: "60%",
            barWidth: 100,
            data: this.value,
            label: {
              show: true,
              position: "top",
              formatter: "{c}",
              fontSize: "40",

              color: "white", //color of value
            },
            itemStyle: {
              show: true,
              color: (params) => {
                let num = this.colorArray.length;
                return {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorArray[params.dataIndex % num].top,
                    },
                    {
                      offset: 1,
                      color: this.colorArray[params.dataIndex % num].bottom,
                    },
                  ],
                  global: false,
                };
              },
              // barBorderRadius: 70,
              borderWidth: 0,
              borderColor: "#333",
            },
          },
        ],
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.manage-cost {
  width: 100%;
  height: 100%;
}
#manageCost {
  width: 100%;
  height: 90%;
}
::v-deep.picker {
  display: flex;
  align-items: center;
  .picker-item {
    width: 45%;
  }
  .el-date-editor.el-input {
    width: auto !important;
  }
  .el-input__inner {
    border: 1px solid rgba(255, 255, 255, 0.27) !important;
    background: none !important;
    color: #fff !important;
  }
}
</style>
<style lang="scss">
::v-deep .el-picker__popper.el-popper {
  background: #011832d9 !important;
  border: 1px solid var(--el-datepicker-border-color);
  box-shadow: var(--el-box-shadow-light);
}
.el-picker-panel {
  color: var(--el-text-color-regular);
  background: #fff0 !important;
  border-radius: var(--el-border-radius-base);
  line-height: 30px;
}
.el-month-table td .cell {
  color: #ffffff !important;
}
.el-month-table td.current:not(.disabled) .cell {
  color: #37aefd !important;
}
.el-picker-panel__icon-btn {
  color: #ffffff !important;
}
.el-date-picker__header-label {
  color: #ffffff;
}
.el-popper__arrow::before {
  background-color: #061f3cbf!important;
  border: 0px !important;
}
</style>